<template>
  <div class="main">
    <img class="icon" src="@/assets/groupBuy/finish.png" alt="" />
    <span class="text">活动已关闭</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  background: #eee;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    width: 14.8rem;
    height: 12.8rem;
    margin-top: 16.1rem;
  }

  .text {
    font-size: 1.3rem;
    color: #999;
    margin-top: 0.7rem;
  }
}
</style>